/* Novu product page: buy box, floating bar, panels, cart drawer, Android notice. No dependencies. */
(function () {
  'use strict';
  var root = document.getElementById('nv-root');
  var dataEl = document.getElementById('nv-data');
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var KEYS = ['white', 'blue', 'pink'];
  var COLOR = {}; D.colors.forEach(function (c) { COLOR[c.key] = c; });
  var NAME_TO_KEY = {}; D.colors.forEach(function (c) { NAME_TO_KEY[c.name.toLowerCase()] = c.key; });
  var ROUTES = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var LOGO = '<svg aria-hidden="true" viewBox="0 0 74 50"><path d="M30 6a20 20 0 1 0 14 34A17 17 0 0 1 30 6z" fill="#17181C"/><path d="M56 6l3 8 8 3-8 3-3 8-3-8-8-3 8-3z" fill="#17181C"/></svg>';
  var TRASH = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
  var XMARK = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M7 7l10 10M17 7L7 17"/></svg>';
  var TRUCK = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';

  function $(id) { return document.getElementById(id); }
  function money(cents) {
    var s = (cents / 100).toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function moneyShort(cents) { return money(cents).replace('.00', ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sum(c) { return c.white + c.blue + c.pink; }
  function countsKey(c) { return KEYS.map(function (k) { return c[k]; }).join(','); }
  function keyOf(name) { return NAME_TO_KEY[String(name || '').toLowerCase().trim()] || null; }

  /* ---------- Variant lookups ---------- */
  function indexVariants(list) {
    var map = {};
    (list || []).forEach(function (v) {
      var c = { white: 0, blue: 0, pink: 0 }; var ok = true;
      (v.options || []).forEach(function (o) { var k = keyOf(o); if (k) c[k] += 1; else ok = false; });
      if (!ok) return;
      var key = countsKey(c);
      if (!map[key] || (!map[key].available && v.available)) map[key] = v;
    });
    return map;
  }
  var V = { 1: indexVariants(D.single.variants), 2: indexVariants(D.two.variants), 3: indexVariants(D.three.variants) };
  var HANDLE_QTY = {}; HANDLE_QTY[D.single.handle] = 1; HANDLE_QTY[D.two.handle] = 2; HANDLE_QTY[D.three.handle] = 3;
  function variantFor(counts) { var n = sum(counts); return V[n] ? V[n][countsKey(counts)] : null; }
  function anyVariant(n) { var m = V[n]; for (var k in m) return m[k]; return null; }
  var PRICE = { 1: (anyVariant(1) || {}).price || 0, 2: (anyVariant(2) || {}).price || 0, 3: (anyVariant(3) || {}).price || 0 };
  var WAS = { 1: 0, 2: (anyVariant(2) || {}).compare_at_price || PRICE[1] * 2, 3: (anyVariant(3) || {}).compare_at_price || PRICE[1] * 3 };
  var MOUNT = D.mount;
  var FREE = D.freeMin;

  /* ---------- Buy box state ---------- */
  var S = { qty: 1, color: 'white', counts: null, mount: false };
  function multi() { return S.qty > 1 && S.counts; }
  function podCounts() { if (multi()) return S.counts; var c = { white: 0, blue: 0, pink: 0 }; c[S.color] = 1; return c; }
  function complete() { return !multi() || sum(S.counts) === S.qty; }
  function orderTotal() { return PRICE[S.qty] + (S.mount && MOUNT ? MOUNT.price : 0); }
  function biggest(c, except) { var best = null; KEYS.forEach(function (k) { if (k !== except && c[k] > 0 && (best === null || c[k] > c[best])) best = k; }); return best; }

  function pickQty(n) {
    if (n === 1) { if (multi()) S.color = biggest(S.counts) || S.color; S.qty = 1; render(); return; }
    var c;
    if (!multi()) { c = { white: 0, blue: 0, pink: 0 }; c[S.color] = n; }
    else {
      c = Object.assign({}, S.counts); var t = sum(c);
      while (t < n) { c[S.color] += 1; t += 1; }
      while (t > n) { var k = biggest(c); c[k] -= 1; t -= 1; }
    }
    S.qty = n; S.counts = c; render();
  }

  function render() {
    root.querySelectorAll('[data-nv-qty]').forEach(function (b) {
      var on = Number(b.getAttribute('data-nv-qty')) === S.qty;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var topTitle = $('nv-title'); if (topTitle) topTitle.innerHTML = 'Novu Pod' + (S.qty > 1 ? ' <span class="nv-h1__pack">' + S.qty + '-Pack</span>' : '');
    var topPrice = $('nv-price-top'); if (topPrice && PRICE[S.qty]) topPrice.textContent = money(PRICE[S.qty]);
    var oneFree = PRICE[1] + (S.mount && MOUNT ? MOUNT.price : 0) >= FREE;
    var oneNote = root.querySelector('[data-nv-one-note]');
    if (oneNote) { oneNote.textContent = oneFree ? 'Ships free' : '+ ' + money(D.shipping) + ' shipping'; oneNote.classList.toggle('nv-tile__note--free', oneFree); }

    $('nv-single').hidden = !!multi();
    $('nv-multi').hidden = !multi();
    root.querySelectorAll('[data-nv-color]').forEach(function (b) {
      var on = b.getAttribute('data-nv-color') === S.color;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $('nv-color-name').textContent = COLOR[S.color].name;
    if (multi()) {
      var total = sum(S.counts);
      KEYS.forEach(function (k) {
        var n = S.counts[k];
        root.querySelector('[data-nv-n="' + k + '"]').textContent = n;
        root.querySelector('[data-nv-row="' + k + '"]').classList.toggle('is-on', n > 0);
        root.querySelector('[data-nv-minus="' + k + '"]').disabled = n <= 0;
        root.querySelector('[data-nv-plus="' + k + '"]').disabled = n >= S.qty;
      });
      var st = $('nv-mix-status');
      st.textContent = total + ' of ' + S.qty + ' chosen';
      st.classList.toggle('is-short', total !== S.qty);
    }

    var tog = $('nv-mount-toggle');
    if (tog && MOUNT) {
      tog.setAttribute('aria-checked', S.mount ? 'true' : 'false');
      var unlocks = PRICE[S.qty] < FREE && PRICE[S.qty] + MOUNT.price >= FREE;
      var note = $('nv-mount-note');
      note.textContent = unlocks ? (S.mount ? '✓ Free shipping unlocked' : 'Unlocks free shipping') : '';
      note.hidden = !unlocks;
      note.classList.toggle('is-done', S.mount);
      var shipnote = $('nv-mount-shipnote'); if (shipnote) shipnote.hidden = !(unlocks && !S.mount);
      var addBtn = $('nv-mount-add'); if (addBtn) addBtn.textContent = S.mount ? 'Done' : 'Add ' + 'Wall Mount · ' + money(MOUNT.price);
    }

    var cta = $('nv-cta');
    if (!complete()) {
      var missing = S.qty - sum(S.counts);
      cta.textContent = 'Choose ' + missing + ' more Pod' + (missing > 1 ? 's' : '');
      cta.disabled = true;
    } else {
      var what = S.qty === 1 ? 'Add to cart' : 'Add ' + S.qty + ' Pods' + (S.mount ? '' : ' to cart');
      if (S.mount) what += ' + Mount';
      cta.textContent = what + ' · ' + money(orderTotal());
      cta.disabled = false;
    }
    renderBar();
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a'); if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-nv-qty')) { pickQty(Number(t.getAttribute('data-nv-qty'))); return; }
    if (t.hasAttribute('data-nv-color')) { S.color = t.getAttribute('data-nv-color'); render(); return; }
    if (t.hasAttribute('data-nv-minus')) { var k = t.getAttribute('data-nv-minus'); if (S.counts[k] > 0) { S.counts[k] -= 1; render(); } return; }
    if (t.hasAttribute('data-nv-plus')) {
      var k2 = t.getAttribute('data-nv-plus'); var c = S.counts;
      if (c[k2] >= S.qty) return;
      if (sum(c) >= S.qty) { var other = biggest(c, k2); if (!other) return; c[other] -= 1; }
      c[k2] += 1; render(); return;
    }
    if (t.id === 'nv-mount-toggle') { S.mount = !S.mount; render(); return; }
    if (t.id === 'nv-mount-add') { S.mount = true; render(); closeTop(); return; }
    if (t.hasAttribute('data-nv-open')) { e.preventDefault(); openLayer('nv-panel-' + t.getAttribute('data-nv-open')); return; }
    if (t.hasAttribute('data-nv-close')) { var thenBuy = t.hasAttribute('data-nv-then-buy'); closeTop(); if (thenBuy) setTimeout(scrollToBuy, 60); return; }
    if (t.hasAttribute('data-nv-scroll-buy')) { e.preventDefault(); scrollToBuy(); return; }
    if (t.id === 'nv-cta' || t.id === 'nv-bar-cta' || t.id === 'nv-order-add') {
      if (!complete()) { closeAll(); scrollToBuy(); return; }
      guardedAdd(); return;
    }
    if (t.id === 'nv-bar-sum') {
      if (window.matchMedia('(min-width: 990px)').matches) { scrollToBuy(); return; }
      renderOrderSheet(); openLayer('nv-panel-order'); return;
    }
    if (t.id === 'nv-android-anyway') { try { sessionStorage.setItem('nvAndroidOk', '1'); } catch (err) {} closeTop(); addToCart(); return; }
  });

  function scrollToBuy() {
    var el = $('nv-cta');
    var top = el.getBoundingClientRect().top + window.pageYOffset - window.innerHeight * 0.55;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  /* ---------- Gallery ---------- */
  var track = $('nv-gallery-track');
  if (track) {
    var counter = $('nv-gallery-n');
    var thumbs = root.querySelectorAll('[data-nv-thumb]');
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (counter) counter.textContent = i + 1;
      thumbs.forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
    }, { passive: true });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () { track.scrollTo({ left: Number(b.getAttribute('data-nv-thumb')) * track.clientWidth, behavior: 'smooth' }); });
    });
  }

  /* ---------- Layers (panels, sheets, drawer) with Back-button support ---------- */
  var stack = [];
  var scrim = $('nv-scrim');
  function lock(on) { document.documentElement.classList.toggle('nv-lock', on); }
  function openLayer(id, noHistory) {
    var el = $(id); if (!el || stack.indexOf(id) !== -1) return;
    stack.push(id); el.hidden = false; scrim.hidden = false; lock(true);
    if (!noHistory) { try { history.pushState({ nvLayer: id }, ''); } catch (err) {} }
    var focusable = el.querySelector('[data-nv-close]'); if (focusable) focusable.focus({ preventScroll: true });
  }
  function hideLayer(id) {
    var el = $(id); if (el) el.hidden = true;
    stack = stack.filter(function (x) { return x !== id; });
    if (!stack.length) { scrim.hidden = true; lock(false); }
  }
  function closeTop() { if (!stack.length) return; if (history.state && history.state.nvLayer) history.back(); else hideLayer(stack[stack.length - 1]); }
  function closeAll() { while (stack.length) hideLayer(stack[stack.length - 1]); }
  window.addEventListener('popstate', function () { if (stack.length) hideLayer(stack[stack.length - 1]); });
  scrim.addEventListener('click', closeTop);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && stack.length) closeTop(); });

  /* ---------- Floating bar ---------- */
  var bar = $('nv-bar'); var ctaEl = $('nv-cta');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var past = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-shown', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    }, { threshold: 0 }).observe(ctaEl);
  }
  function dotsHtml(keys) { return keys.map(function (k) { return '<i style="--fill:' + COLOR[k].fill + '"></i>'; }).join(''); }
  function presentKeys(c) { return KEYS.filter(function (k) { return c[k] > 0; }); }
  function renderBar() {
    var c = podCounts(); var total = orderTotal(); var free = total >= FREE;
    var savings = WAS[S.qty] ? WAS[S.qty] - PRICE[S.qty] : 0;
    $('nv-bar-dots').innerHTML = dotsHtml(presentKeys(c));
    var label = S.qty === 1 ? (S.mount ? '1 Pod + Mount' : '1 Pod · ' + COLOR[S.color].name) : S.qty + ' Pods' + (S.mount ? ' + Mount' : (savings > 0 ? ' · save ' + moneyShort(savings) : ''));
    $('nv-bar-label').textContent = label;
    $('nv-bar-total').textContent = money(total);
    var tag = $('nv-bar-tag'); tag.textContent = free ? 'Free shipping' : '+ ' + money(D.shipping) + ' shipping'; tag.classList.toggle('is-free', free);
    var bc = $('nv-bar-cta'); bc.textContent = complete() ? 'Add to cart' : 'Choose colors'; bc.classList.toggle('is-wait', !complete());
  }

  function podChips(keysList, size) {
    var dims = { 1: [44, 30, 8], 2: [34, 23, 7], 3: [26, 18, 5] }[keysList.length] || [26, 18, 5];
    return keysList.map(function (k) { return '<span class="nv-podchip" style="--fill:' + COLOR[k].fill + ';width:' + dims[0] + 'px;height:' + dims[1] + 'px;border-radius:' + dims[2] + 'px">' + LOGO + '</span>'; }).join('');
  }
  function expand(c) { var out = []; KEYS.forEach(function (k) { for (var i = 0; i < c[k]; i++) out.push(k); }); return out; }
  function colorSummary(c, withCounts) { return presentKeys(c).map(function (k) { return (withCounts ? c[k] + ' ' : '') + COLOR[k].name; }).join(', '); }

  function renderOrderSheet() {
    var c = podCounts(); var total = orderTotal(); var free = total >= FREE;
    var savings = WAS[S.qty] ? WAS[S.qty] - PRICE[S.qty] : 0;
    var html = '<div class="nv-lines">';
    html += '<div class="nv-line"><span class="nv-line__img">' + podChips(expand(c)) + '</span><div class="nv-line__main"><div class="nv-line__top"><span class="nv-line__title">' + (S.qty === 1 ? 'Novu Pod' : S.qty + ' Novu Pods') + '</span><span class="nv-line__price">' + (WAS[S.qty] ? '<s>' + money(WAS[S.qty]) + '</s>' : '') + '<b>' + money(PRICE[S.qty]) + '</b></span></div><span class="nv-line__sub">' + esc(complete() ? colorSummary(c, S.qty > 1) : 'Colors not finished') + '</span></div></div>';
    if (S.mount && MOUNT) html += '<div class="nv-line"><span class="nv-line__img">' + (MOUNT.image ? '<img src="' + esc(MOUNT.image) + '" alt="">' : '') + '</span><div class="nv-line__main"><div class="nv-line__top"><span class="nv-line__title">Novu Wall Mount</span><span class="nv-line__price"><b>' + money(MOUNT.price) + '</b></span></div><span class="nv-line__sub">Holds one Pod on most walls and doors</span></div></div>';
    html += '</div>';
    if (MOUNT && !S.mount && !free && PRICE[S.qty] + MOUNT.price >= FREE) {
      html += '<div class="nv-offers"><div class="nv-offer nv-offer--dashed"><div class="nv-offer__row">' + (MOUNT.image ? '<img src="' + esc(MOUNT.image) + '" alt="">' : '') + '<span class="nv-offer__txt"><b>Novu Wall Mount <span>+' + money(MOUNT.price) + '</span></b><small>Your whole order ships free</small></span><button type="button" class="nv-pill" id="nv-order-mount">Add</button></div></div></div>';
    }
    html += '<div class="nv-totals"><div><span>Subtotal</span><b>' + money(total) + '</b></div><div><span>Shipping</span><b class="' + (free ? 'is-free' : '') + '">' + (free ? 'Free' : money(D.shipping)) + '</b></div>';
    if (savings > 0) html += '<div class="nv-save"><span>You save</span><span>' + moneyShort(savings) + '</span></div>';
    html += '<div class="nv-grand"><span>Total<small>Tax calculated at checkout</small></span><b>' + money(total + (free ? 0 : D.shipping)) + '</b></div></div>';
    $('nv-order-body').innerHTML = html;
    var om = $('nv-order-mount'); if (om) om.addEventListener('click', function () { S.mount = true; render(); renderOrderSheet(); });
  }

  /* ---------- Add to cart (with Android notice) ---------- */
  function isAndroid() { return /Android/i.test(navigator.userAgent || ''); }
  function guardedAdd() {
    var ok = false; try { ok = sessionStorage.getItem('nvAndroidOk') === '1'; } catch (err) {}
    if (isAndroid() && !ok) { closeAll(); openLayer('nv-panel-android'); return; }
    addToCart();
  }
  // Cheapest packing for a set of Pod colors: as many 3-Packs as possible, then a 2-Pack or a single.
  function planFor(total) {
    var flat = []; KEYS.forEach(function (k) { for (var i = 0; i < total[k]; i++) flat.push(k); });
    var desired = {}; var cost = 0;
    for (var i = 0; i < flat.length;) {
      var left = flat.length - i; var size = left >= 3 ? 3 : left;
      var c = { white: 0, blue: 0, pink: 0 }; flat.slice(i, i + size).forEach(function (k) { c[k] += 1; });
      var v = variantFor(c); if (!v || v.available === false) return null;
      desired[v.id] = (desired[v.id] || 0) + 1; cost += PRICE[size]; i += size;
    }
    return { desired: desired, cost: cost };
  }
  // Pod lines in the cart: total colors, current cost, variant ids (null if a variant sits on two lines).
  function podState(items) {
    var total = { white: 0, blue: 0, pink: 0 }; var cost = 0; var seen = {}; var lines = 0; var dup = false;
    (items || []).forEach(function (it) {
      var inf = classify(it); if (inf.type !== 'pod') return;
      if (seen[it.variant_id]) dup = true; seen[it.variant_id] = true; lines += 1;
      KEYS.forEach(function (k) { total[k] += inf.counts[k] * it.quantity; });
      cost += PRICE[inf.size] * it.quantity;
    });
    return dup ? null : { total: total, cost: cost, seen: seen, lines: lines };
  }
  // cart/update.js map that turns the cart's Pod lines into the cheapest packing of `total`.
  function regroupUpdates(state, total) {
    var plan = planFor(total); if (!plan) return null;
    var updates = {};
    Object.keys(state.seen).forEach(function (id) { updates[id] = plan.desired[id] || 0; });
    Object.keys(plan.desired).forEach(function (id) { updates[id] = plan.desired[id]; });
    return updates;
  }
  // Adding while the cart already has Pods: regroup all of them (colors kept) into the cheapest packs.
  // Returns an updates map for cart/update.js, or null to fall back to a plain add.
  function mergePlan(cart, addCounts) {
    var st = podState(cart && cart.items); if (!st || !st.lines) return null;
    var total = { white: st.total.white + addCounts.white, blue: st.total.blue + addCounts.blue, pink: st.total.pink + addCounts.pink };
    var plan = planFor(total); if (!plan || plan.cost >= st.cost + PRICE[sum(addCounts)]) return null;
    return regroupUpdates(st, total);
  }
  function addToCart() {
    var counts = podCounts(); var v = variantFor(counts);
    if (!v) { alertInline('That color mix isn’t available right now.'); return; }
    var items = [{ id: v.id, quantity: 1 }];
    if (S.mount && MOUNT) items.push({ id: MOUNT.variant, quantity: 1 });
    var cta = $('nv-cta'); cta.classList.add('is-busy');
    getCart().catch(function () { return null; })
      .then(function (cart) {
        var updates = cart ? mergePlan(cart, counts) : null;
        if (!updates) return post('cart/add.js', { items: items, sections: 'cart-icon-bubble', sections_url: window.location.pathname });
        if (S.mount && MOUNT) {
          var have = 0; cart.items.forEach(function (it) { if (it.variant_id === MOUNT.variant) have += it.quantity; });
          updates[MOUNT.variant] = have + 1;
        }
        return post('cart/update.js', { updates: updates, sections: 'cart-icon-bubble', sections_url: window.location.pathname });
      })
      .then(function (res) { updateBubble(res && res.sections); closeAll(); return openCart(); })
      .catch(function (err) { alertInline(err && err.message ? err.message : 'Couldn’t add to cart. Please try again.'); })
      .then(function () { cta.classList.remove('is-busy'); });
  }
  function alertInline(msg) {
    var cta = $('nv-cta'); var p = document.createElement('p');
    p.textContent = msg; p.style.cssText = 'color:#B4530F;font-size:13px;font-weight:600;text-align:center;margin:0';
    cta.insertAdjacentElement('afterend', p); setTimeout(function () { p.remove(); }, 4000);
  }

  /* ---------- Cart API ---------- */
  function post(path, body) {
    return fetch(ROUTES + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Cart error'); return j; }); });
  }
  function getCart() { return fetch(ROUTES + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function updateBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (html && bubble) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('.shopify-section'); bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
    } else if (bubble) {
      fetch(window.location.pathname + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(updateBubble).catch(function () {});
    }
  }

  /* ---------- Cart drawer ---------- */
  var drawerBody = $('nv-drawer-body'); var drawerFoot = $('nv-drawer-foot');
  var cartState = null; var upColor = 'white'; var busy = false;

  function classify(item) {
    var q = HANDLE_QTY[item.handle];
    if (q) {
      var c = { white: 0, blue: 0, pink: 0 };
      (item.options_with_values || []).forEach(function (o) { var k = keyOf(o.value); if (k) c[k] += 1; });
      return { type: 'pod', size: q, counts: c };
    }
    if (MOUNT && item.handle === MOUNT.handle) return { type: 'mount' };
    return { type: 'other' };
  }
  function openCart() { openLayer('nv-drawer'); return refreshCart(); }
  function refreshCart() {
    return getCart().then(function (cart) { cartState = cart; renderCart(); });
  }
  function runOps(ops) {
    if (busy) return Promise.resolve(); busy = true; drawerBody.classList.add('nv-busy');
    var p = Promise.resolve();
    ops.forEach(function (op) { p = p.then(function () { return post(op[0], op[1]); }); });
    return p.catch(function (err) { console.warn('[novu] cart', err); })
      .then(function () { busy = false; drawerBody.classList.remove('nv-busy'); updateBubble(); return refreshCart(); });
  }
  // Replace one unit of a pod line with a different Pod combination (or remove it when the new count is 0).
  function swapUnit(item, newCounts) {
    var ops = [['cart/change.js', { id: item.key, quantity: item.quantity - 1 }]];
    if (sum(newCounts) > 0) { var v = variantFor(newCounts); if (!v) return; ops.push(['cart/add.js', { items: [{ id: v.id, quantity: 1 }] }]); }
    runOps(ops);
  }

  function removeBtn(idx, label, what) {
    return '<button type="button" class="nv-remove" data-nv-lineremove="' + idx + '" aria-label="' + esc(label + ' ' + (what || '')) + '">' + TRASH + '<span>' + label + '</span></button>';
  }
  // Remove `less` Pods from the cart and regroup the rest into the cheapest packs, in one request.
  function podRemovalOps(items, item, less) {
    var st = podState(items);
    if (st) {
      var total = {}; KEYS.forEach(function (k) { total[k] = Math.max(0, st.total[k] - less[k]); });
      var updates = regroupUpdates(st, total);
      if (updates) return [['cart/update.js', { updates: updates }]];
    }
    return null;
  }
  function renderCart() {
    var cart = cartState; if (!cart) return;
    var items = cart.items || [];
    $('nv-drawer-count').textContent = '(' + cart.item_count + ')';
    if (!items.length) {
      drawerBody.innerHTML = '<div class="nv-empty"><b>Your cart is empty</b><span>Your mornings are still waiting.</span><button type="button" class="nv-cta" style="width:auto;padding:14px 26px;font-size:16px" data-nv-close data-nv-then-buy>Shop Novu Pod</button></div>';
      drawerFoot.innerHTML = ''; return;
    }
    var total = cart.total_price; var free = total >= FREE;
    var html = '<div class="nv-progress' + (free ? ' is-free' : '') + '"><span class="nv-progress__msg">' + TRUCK + (free ? '<span>Your order ships free</span>' : '<span>You’re <b>' + money(FREE - total) + '</b> away from free shipping</span>') + '</span><span class="nv-progress__bar"><span style="width:' + Math.max(4, Math.min(100, Math.round(total / FREE * 100))) + '%"></span></span></div>';
    html += '<div class="nv-lines">';
    var pods = 0; var firstSmall = null; var mounts = 0; var savings = 0;
    var RANK = { pod: 0, mount: 1, other: 2 };
    var ordered = items.map(function (item, idx) { return { item: item, idx: idx, info: classify(item) }; })
      .sort(function (a, b) { return RANK[a.info.type] - RANK[b.info.type] || a.idx - b.idx; });
    ordered.forEach(function (row) {
      var item = row.item; var idx = row.idx; var info = row.info;
      if (item.original_line_price > item.final_line_price) savings += item.original_line_price - item.final_line_price;
      if (info.type === 'pod') {
        pods += info.size * item.quantity;
        if (info.size < 3 && !firstSmall) firstSmall = { item: item, info: info };
        var was = WAS[info.size] ? WAS[info.size] * item.quantity : 0;
        if (was > item.final_line_price) savings += was - item.final_line_price;
        var keysList = expand(info.counts);
        var title = info.size === 1 ? 'Novu Pod' : 'Novu Pod ' + info.size + '-Pack';
        html += '<div class="nv-line"><span class="nv-line__img">' + podChips(keysList) + '</span><div class="nv-line__main"><div class="nv-line__top"><span class="nv-line__title">' + title + (item.quantity > 1 ? ' × ' + item.quantity : '') + '</span><span class="nv-line__price">' + (was > item.final_line_price ? '<s>' + money(was) + '</s>' : '') + '<b>' + money(item.final_line_price) + '</b></span></div>';
        if (info.size === 1) {
          html += '<div class="nv-line__row"><span class="nv-line__sub">' + esc(COLOR[keysList[0]] ? COLOR[keysList[0]].name : item.variant_title) + '</span>' + removeBtn(idx, 'Remove', title) + '</div>';
        } else {
          keysList.forEach(function (k) { html += '<div class="nv-podrow"><span>' + COLOR[k].name + '</span><button type="button" class="nv-x" data-nv-podremove="' + idx + '" data-nv-rm="' + k + '" aria-label="Remove one ' + COLOR[k].name + ' Pod">' + XMARK + '</button></div>'; });
          html += '<div class="nv-line__row nv-line__row--end">' + removeBtn(idx, 'Remove pack', title) + '</div>';
        }
        html += '</div></div>';
      } else if (info.type === 'mount') {
        mounts += item.quantity;
        html += '<div class="nv-line"><span class="nv-line__img">' + (item.image ? '<img src="' + esc(item.image) + '" alt="">' : '') + '</span><div class="nv-line__main"><div class="nv-line__top"><span class="nv-line__title">' + esc(item.product_title) + '</span><span class="nv-line__price"><b>' + money(item.final_line_price) + '</b></span></div><span class="nv-line__sub">Holds one Pod on most walls and doors</span><div class="nv-line__row"><span class="nv-qty"><button type="button" data-nv-mountqty="' + idx + '" data-d="-1" aria-label="One fewer">−</button><span>' + item.quantity + '</span><button type="button" data-nv-mountqty="' + idx + '" data-d="1" aria-label="One more">+</button></span>' + removeBtn(idx, 'Remove', item.product_title) + '</div></div></div>';
      } else {
        html += '<div class="nv-line"><span class="nv-line__img">' + (item.image ? '<img src="' + esc(item.image) + '" alt="">' : '') + '</span><div class="nv-line__main"><div class="nv-line__top"><span class="nv-line__title">' + esc(item.product_title) + '</span><span class="nv-line__price"><b>' + money(item.final_line_price) + '</b></span></div>' + (item.variant_title ? '<span class="nv-line__sub">' + esc(item.variant_title) + '</span>' : '') + '<div class="nv-line__row"><span class="nv-qty"><button type="button" data-nv-otherqty="' + idx + '" data-d="-1" aria-label="One fewer">−</button><span>' + item.quantity + '</span><button type="button" data-nv-otherqty="' + idx + '" data-d="1" aria-label="One more">+</button></span>' + removeBtn(idx, 'Remove', item.product_title) + '</div></div></div>';
      }
    });
    html += '</div>';

    // Offers: next Pod (upgrade the first 1- or 2-Pod line) and the Wall Mount.
    var offers = '';
    if (firstSmall && pods < 3) {
      var size = firstSmall.info.size; var next = size + 1;
      var extra = PRICE[next] - PRICE[size];
      offers += '<div class="nv-offer"><div class="nv-offer__row"><span class="nv-offer__txt"><b>Add a ' + (size === 1 ? '2nd' : '3rd') + ' Pod · +' + money(extra) + '</b><small>' + (next === 2 ? 'Becomes a 2-Pack · ships free' : 'Becomes a 3-Pack · ' + money(Math.round(PRICE[3] / 3)) + ' per Pod') + '</small></span><button type="button" class="nv-pill" data-nv-upgrade>Add</button></div><div class="nv-offer__colors">' +
        KEYS.map(function (k) { return '<button type="button" data-nv-upcolor="' + k + '" class="' + (k === upColor ? 'is-on' : '') + '" aria-label="' + COLOR[k].name + '" aria-pressed="' + (k === upColor) + '" style="--fill:' + COLOR[k].fill + '">' + LOGO + '</button>'; }).join('') + '<span>' + COLOR[upColor].name + '</span></div></div>';
    }
    if (MOUNT && mounts === 0 && pods > 0) {
      var unlocks = !free && total + MOUNT.price >= FREE;
      offers += '<div class="nv-offer"><div class="nv-offer__row">' + (MOUNT.image ? '<img src="' + esc(MOUNT.image) + '" alt="">' : '') + '<span class="nv-offer__txt"><b>Novu Wall Mount <span>+' + money(MOUNT.price) + '</span></b><small class="' + (unlocks ? '' : 'is-plain') + '">' + (unlocks ? 'Your whole order ships free' : 'Holds a Pod on most walls and doors') + '</small></span><button type="button" class="nv-pill" data-nv-addmount>Add</button></div></div>';
    }
    if (offers) html += '<div><span class="nv-label">ADD TO YOUR ORDER</span><div class="nv-offers" style="margin-top:8px">' + offers + '</div></div>';
    drawerBody.innerHTML = html;
    drawerBody._items = items;

    var foot = '<div class="nv-sub"><span>Subtotal</span><b>' + money(total) + '</b></div>';
    foot += '<div class="nv-subrow"><span>Shipping</span><b class="' + (free ? 'is-free' : '') + '">' + (free ? 'Free' : money(D.shipping)) + '</b></div>';
    if (savings > 0) foot += '<div class="nv-subrow" style="color:#1F7A4D;font-weight:700"><span>You save</span><span>' + moneyShort(savings) + '</span></div>';
    foot += '<a class="nv-checkout" href="' + ROUTES + 'checkout">Check out</a><span class="nv-fine">Apple Pay and Shop Pay at checkout · Taxes calculated at checkout · 30-day returns</span>';
    drawerFoot.innerHTML = foot;
  }

  drawerBody.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t) return;
    var items = drawerBody._items || [];
    if (t.hasAttribute('data-nv-podremove')) {
      var item = items[Number(t.getAttribute('data-nv-podremove'))]; var info = classify(item);
      var c = Object.assign({}, info.counts); var k = t.getAttribute('data-nv-rm'); if (c[k] > 0) c[k] -= 1;
      var less = { white: 0, blue: 0, pink: 0 }; less[k] = 1;
      var ops = podRemovalOps(items, item, less);
      if (!ops) {
        ops = [['cart/change.js', { id: item.key, quantity: item.quantity - 1 }]];
        if (sum(c) > 0) { var v = variantFor(c); if (v) ops.push(['cart/add.js', { items: [{ id: v.id, quantity: 1 }] }]); }
      }
      runOps(ops); return;
    }
    if (t.hasAttribute('data-nv-lineremove')) {
      var line = items[Number(t.getAttribute('data-nv-lineremove'))]; var lineInfo = classify(line); var lineOps = null;
      if (lineInfo.type === 'pod') {
        var gone = {}; KEYS.forEach(function (k2) { gone[k2] = lineInfo.counts[k2] * line.quantity; });
        lineOps = podRemovalOps(items, line, gone);
      }
      runOps(lineOps || [['cart/change.js', { id: line.key, quantity: 0 }]]); return;
    }
    if (t.hasAttribute('data-nv-upcolor')) { upColor = t.getAttribute('data-nv-upcolor'); renderCart(); return; }
    if (t.hasAttribute('data-nv-upgrade')) {
      var target = null; items.forEach(function (it) { var inf = classify(it); if (!target && inf.type === 'pod' && inf.size < 3) target = { it: it, inf: inf }; });
      if (!target) return; var nc = Object.assign({}, target.inf.counts); nc[upColor] += 1; swapUnit(target.it, nc); return;
    }
    if (t.hasAttribute('data-nv-addmount')) { runOps([['cart/add.js', { items: [{ id: MOUNT.variant, quantity: 1 }] }]]); return; }
    if (t.hasAttribute('data-nv-mountqty') || t.hasAttribute('data-nv-otherqty')) {
      var it2 = items[Number(t.getAttribute('data-nv-mountqty') || t.getAttribute('data-nv-otherqty'))];
      runOps([['cart/change.js', { id: it2.key, quantity: Math.max(0, it2.quantity + Number(t.getAttribute('data-d'))) }]]); return;
    }
  });

  // On this page the header cart icon opens the Novu drawer instead of Dawn's.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('#cart-icon-bubble'); if (!link) return;
    e.preventDefault(); e.stopPropagation(); openCart();
  }, true);

  /* ---------- Android waitlist ---------- */
  var form = document.getElementById('nv-android-form');
  if (form) form.addEventListener('submit', function () { try { sessionStorage.setItem('nvAndroidJoined', '1'); } catch (err) {} });
  try {
    if (/customer_posted=true/.test(location.search) && sessionStorage.getItem('nvAndroidJoined') === '1') {
      sessionStorage.removeItem('nvAndroidJoined');
      $('nv-waitlist').hidden = true; $('nv-waitlist-done').hidden = false; openLayer('nv-panel-android');
    }
  } catch (err) {}

  // Arriving from the homepage's "2 Pods" / "3 Pods" buttons (?pods=2 or ?pods=3) preselects that tile.
  // Otherwise the 2-Pack and 3-Pack product pages open on their own pack (D.start).
  var startQty = 0; try { startQty = Number(new URLSearchParams(window.location.search).get('pods')); } catch (err) {}
  if (startQty !== 2 && startQty !== 3) startQty = Number(D.start) || 1;
  if (startQty === 2 || startQty === 3) pickQty(startQty); else render();
})();
